import { SectionForSelector } from '../../../../types/Sections';

export const sortSectionDropdown = (section: SectionForSelector[]): SectionForSelector[] => {
  return section.sort((a, b) => a.name.localeCompare(b.name));
};
